import React from 'react';
import { ToastContainer } from 'react-toastify';
import SetupChecklistPanel from '../components/SetupChecklistPanel';

const SetupChecklistApp = (props) => (
  <>
    <SetupChecklistPanel {...props} />
    <ToastContainer icon={false} />
  </>
);

export default SetupChecklistApp;
